import { Prefecture } from '@/types/schema.generated'
import type { Jisx0402Code } from '@/features/prefecture/jisx0402'

// TODO: map一つにまとめる
const prefectureLabels: { [_ in Prefecture]: string } = {
  [Prefecture.Hokkaido]: '北海道',
  [Prefecture.Aomori]: '青森県',
  [Prefecture.Iwate]: '岩手県',
  [Prefecture.Miyagi]: '宮城県',
  [Prefecture.Akita]: '秋田県',
  [Prefecture.Yamagata]: '山形県',
  [Prefecture.Fukushima]: '福島県',
  [Prefecture.Ibaraki]: '茨城県',
  [Prefecture.Tochigi]: '栃木県',
  [Prefecture.Gunma]: '群馬県',
  [Prefecture.Saitama]: '埼玉県',
  [Prefecture.Chiba]: '千葉県',
  [Prefecture.Tokyo]: '東京都',
  [Prefecture.Kanagawa]: '神奈川県',
  [Prefecture.Niigata]: '新潟県',
  [Prefecture.Toyama]: '富山県',
  [Prefecture.Ishikawa]: '石川県',
  [Prefecture.Fukui]: '福井県',
  [Prefecture.Yamanashi]: '山梨県',
  [Prefecture.Nagano]: '長野県',
  [Prefecture.Gifu]: '岐阜県',
  [Prefecture.Shizuoka]: '静岡県',
  [Prefecture.Aichi]: '愛知県',
  [Prefecture.Mie]: '三重県',
  [Prefecture.Shiga]: '滋賀県',
  [Prefecture.Kyoto]: '京都府',
  [Prefecture.Osaka]: '大阪府',
  [Prefecture.Hyogo]: '兵庫県',
  [Prefecture.Nara]: '奈良県',
  [Prefecture.Wakayama]: '和歌山県',
  [Prefecture.Tottori]: '鳥取県',
  [Prefecture.Shimane]: '島根県',
  [Prefecture.Okayama]: '岡山県',
  [Prefecture.Hiroshima]: '広島県',
  [Prefecture.Yamaguchi]: '山口県',
  [Prefecture.Tokushima]: '徳島県',
  [Prefecture.Kagawa]: '香川県',
  [Prefecture.Ehime]: '愛媛県',
  [Prefecture.Kochi]: '高知県',
  [Prefecture.Fukuoka]: '福岡県',
  [Prefecture.Saga]: '佐賀県',
  [Prefecture.Nagasaki]: '長崎県',
  [Prefecture.Kumamoto]: '熊本県',
  [Prefecture.Oita]: '大分県',
  [Prefecture.Miyazaki]: '宮崎県',
  [Prefecture.Kagoshima]: '鹿児島県',
  [Prefecture.Okinawa]: '沖縄県',
} as const

export const allPrefectures = () =>
  Object.keys(prefectureLabels) as Prefecture[]
export const prefectureLabel = (prefecture: Prefecture): string =>
  prefectureLabels[prefecture]

const prefectureCodes: { [_ in Prefecture]: Jisx0402Code } = {
  [Prefecture.Hokkaido]: '010006',
  [Prefecture.Aomori]: '020001',
  [Prefecture.Iwate]: '030007',
  [Prefecture.Miyagi]: '040002',
  [Prefecture.Akita]: '050008',
  [Prefecture.Yamagata]: '060003',
  [Prefecture.Fukushima]: '070009',
  [Prefecture.Ibaraki]: '080004',
  [Prefecture.Tochigi]: '090000',
  [Prefecture.Gunma]: '100005',
  [Prefecture.Saitama]: '110001',
  [Prefecture.Chiba]: '120006',
  [Prefecture.Tokyo]: '130001',
  [Prefecture.Kanagawa]: '140007',
  [Prefecture.Niigata]: '150002',
  [Prefecture.Toyama]: '160008',
  [Prefecture.Ishikawa]: '170003',
  [Prefecture.Fukui]: '180009',
  [Prefecture.Yamanashi]: '190004',
  [Prefecture.Nagano]: '200000',
  [Prefecture.Gifu]: '210005',
  [Prefecture.Shizuoka]: '220001',
  [Prefecture.Aichi]: '230006',
  [Prefecture.Mie]: '240001',
  [Prefecture.Shiga]: '250007',
  [Prefecture.Kyoto]: '260002',
  [Prefecture.Osaka]: '270008',
  [Prefecture.Hyogo]: '280003',
  [Prefecture.Nara]: '290009',
  [Prefecture.Wakayama]: '300004',
  [Prefecture.Tottori]: '310000',
  [Prefecture.Shimane]: '320005',
  [Prefecture.Okayama]: '330001',
  [Prefecture.Hiroshima]: '340006',
  [Prefecture.Yamaguchi]: '350001',
  [Prefecture.Tokushima]: '360007',
  [Prefecture.Kagawa]: '370002',
  [Prefecture.Ehime]: '380008',
  [Prefecture.Kochi]: '390003',
  [Prefecture.Fukuoka]: '400009',
  [Prefecture.Saga]: '410004',
  [Prefecture.Nagasaki]: '420000',
  [Prefecture.Kumamoto]: '430005',
  [Prefecture.Oita]: '440001',
  [Prefecture.Miyazaki]: '450006',
  [Prefecture.Kagoshima]: '460001',
  [Prefecture.Okinawa]: '470007',
} as const

export const toJisx0402Code = (prefecture: Prefecture) =>
  prefectureCodes[prefecture]
